(function () {
    'use strict';

    angular
        .module('assets.mybimiboo.com')
        .controller('EmployeeCtrl', EmployeeCtrl);

    function EmployeeCtrl($scope, $state, $location, $http, AuthenticationService, _env) {

        function getEmployees() {
            $http.get(_env.apiUrl + '/employees').then(function (response) {
                $scope.employees = response.data;
            });
        }

        getEmployees();

        $scope.editEmployee = function(employee) {
            if (employee) {
                $scope.employee = angular.copy(employee);
            } else {
                $scope.employee = {}
            }

            $('#modal-default').modal('show');
        }

        $scope.saveEmployee = function () {
            if (!$scope.employee) return;

            if (!$scope.employee.name) {
                error('Name is required');
                return;
            }

            if (!$scope.employee.email) {
                error('Email is required');
                return;
            }

            var data = {
                email: $scope.employee.email,
                name: $scope.employee.name
            };

            $scope.proccessing = true;

            if ($scope.employee.id) {
                $http.put(_env.apiUrl + '/employees/' + $scope.employee.id, data).then(function(response) {
                    $('#modal-default').modal('hide');
                    getEmployees();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            } else {
                $http.post(_env.apiUrl + '/employees', data).then(function(response) {
                    $('#modal-default').modal('hide');
                    getEmployees();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            }
        }

        $scope.deleteEmployee = function () {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    $scope.proccessing = true;
                    $http.delete(_env.apiUrl + '/employees/' + $scope.employee.id).then(function () {
                        $('#modal-default').modal('hide');
                        getEmployees();
                        Swal.fire({
                            type: 'success',
                            title: 'Employee successfully deleted',
                            position: 'top-end',
                            timer: 1000
                        });
                    }, function (reason) {
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: JSON.stringify(reason.data, null, 2)
                        });
                    });
                }
            });
        }
    }
})();